import { notifyDesignerAuthenticationRequired } from "../Utils/designerAuthentication";
import { IsDesignMode } from "../Utils/runtimeDetection";

import { designerRequestOptions } from "../Utils/designerCachePolicy";

export class ReactArtifactAuthenticationError extends Error {}

export async function fetchReactArtifact(
  url: string,
  getAccessToken: () => Promise<string | undefined>,
  designerOrigin?: string,
  embedFetch?: (url: RequestInfo, init?: RequestInit) => Promise<Response>
): Promise<Response> {
  if (embedFetch) {
    const response = await embedFetch(url);
    if (!response.ok) {
      throw new Error(`Could not load public React artifact (${response.status}).`);
    }
    return response;
  }
  const accessToken = await getAccessToken();
  if (IsDesignMode && !accessToken) {
    notifyDesignerAuthenticationRequired(designerOrigin, "token-unavailable");
    throw new ReactArtifactAuthenticationError("Sign in to the app runtime to load the React preview.");
  }

  const response = await fetch(url, designerRequestOptions({
    credentials: "include",
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
  }));
  if (response.status === 401) {
    notifyDesignerAuthenticationRequired(designerOrigin, "unauthorized");
    throw new ReactArtifactAuthenticationError("The app runtime session expired. Sign in again to load the React preview.");
  }
  if (!response.ok) {
    throw new Error(`Could not load React build artifact '${url}' (${response.status}).`);
  }

  return response;
}
